
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: '', align: 'center', value: 'custom' },
  { text: 'Aggregator Name', value: 'aggregator_name', align: 'start' },
  { text: 'Merchant Name', value: 'merchant_name', align: 'start' },
  { text: 'Tipe Merchant', value: 'merchant_type_name', width: '150', align: 'start' },
  { text: 'MID', value: 'mid', width: '150', align: 'start' },
  { text: 'NMID', value: 'nmid', width: '150', align: 'start' },
  { text: 'No Rekening', value: 'account_number', width: '150', align: 'start' },
  { text: 'Kriteria Merchant', value: 'merchant_criteria', align: 'center' },
  { text: 'Settlement Type', value: 'settlement_type', align: 'center', },
  { text: 'Jenis QR', value: 'qr_type', width: '150', align: 'start' }
]);

export const editedItem = {
  mid: '',
  nmid: '',
  merchant_criteria: '',
  qr_type: ''
};

export const search = {
  settlement_type: '',
  mid: '',
  nmid: '',
  merchant_criteria: '',
  qr_type: '',
  merchant_type: '',
  account_number: ''
};

export const listMerchantType = [
  { value: '1', text: 'Merchant' },
  { value: '3', text: 'Sub Merchant' }
];

export const settlementTypeitems = [
  { value: '0', text: 'H+0' },
  { value: '1', text: 'H+1' }
];

